import {
  anHourFromNow,
  getCurrentDateTime,
  getDatePart,
  getTimePart,
} from "@common/components/helpers/datetime";
import BaseReducer from "./BaseReducer";

class CustomerInteractionReducer extends BaseReducer {
  domain = "CustomerInteraction";
  type = "View";

  initialState = {
    interactionDate: getDatePart(getCurrentDateTime()),
    interactionTime: getTimePart(getCurrentDateTime()),

    // For form input field display purpose
    searchedCustomer: null,
    // The actual selected customer
    customer: null,
    // Hide customer search when customer is pre-selected (e.g. from review modal)
    hideCustomerSearch: false,

    isCustomerVulnerable: null,
    flagCustomer: null,
    customerUnknown: false,

    // The reason selection object consist of id and name
    reason: null,

    // The outcome selection object consist of id and name
    outcome: null,
    // A string to record the description if the outcome choice is "Other"
    otherOutcome: "",

    providedLeaflet: null,
    reasonNotProvidedLeaflet: "",

    seekHelp: null,
    reasonNotSeekHelp: "",

    discussedSelfExclusion: null,
    reasonNotDiscussedSelfExclusion: "",
    selfExclude: null,
    reasonNotSelfExclude: "",
    reviewDate: getDatePart(getCurrentDateTime()),

    setReminder: null,
    reminderDate: getDatePart(anHourFromNow()),
    reminderTime: getTimePart(anHourFromNow()),

    // Comment field for GDPR
    comments: "",

    // Compliance Alerts and Linked Sessions
    complianceAlertId: null,
  };
}

const reducer = new CustomerInteractionReducer();

export default reducer;
